import { OpenHouse } from '../../types/OpenHouse';
import { RepliersListing } from '../../types/repliers/RepliersListing';
import tzlookup from 'tz-lookup';

export default function getOpenHousesFromRepliersListing(
  repliersListing: RepliersListing,
): Array<OpenHouse> {
  const listingTimezone = tzlookup(
    Number(repliersListing.map.latitude),
    Number(repliersListing.map.longitude),
  );

  // Repliers always gives 3 key-value pairs for open house slots, even if some or all are blank. So we must filter out the blank ones
  const repliersOpenHouses = Object.values(repliersListing.openHouse).filter(
    repliersOpenHouse =>
      Boolean(repliersOpenHouse.date) &&
      Boolean(repliersOpenHouse.startTime) &&
      Boolean(repliersOpenHouse.endTime),
  );

  return repliersOpenHouses.map(repliersOpenHouse =>
    OpenHouse.fromRepliersOpenHouseAndListingTimezone(
      repliersOpenHouse,
      listingTimezone,
      repliersListing.resource,
    ),
  );
}
